import { CmsHtmlProps } from '~/types/Cms';
import { wrapTextNodes } from '~/utils/wrapTextNodes';

const CmsHtml = ({ data, disableAutop = false }: CmsHtmlProps) => {
  const html = disableAutop ? data.content : wrapTextNodes(data.content);
  return <div className="cms-text" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default CmsHtml;
